import React from 'react';
import { useLocation } from 'react-router';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Content, LogoMotorway } from '@motorway/motorway-storybook-cra';

import { HOME_PAGE_ROUTES } from 'Utilities/routing';

import useShowNewHomepage from '../homepage/Hooks/useShowNewHomepage';

import AccountLinks from './AccountLinks';
import HeaderLinks from './HeaderLinks';
import LocalTexts from './HeaderTexts.json';

import styles from './Header.scss';

const LocalT = new MDText(LocalTexts);

const Header = () => {
  const { showNewHomepage } = useShowNewHomepage();

  const { pathname } = useLocation();
  const isNewHomepageRoute = HOME_PAGE_ROUTES.includes(pathname);

  const showTransparentHeader = [
    showNewHomepage,
    isNewHomepageRoute,
  ].every((condition) => condition === true);

  return (
    <>
      <div className={cx(
        styles.headerBackground,
        { [styles.bgTransparent]: showTransparentHeader },
      )}/>
      <header className={cx(styles.header, { [styles.nextHomepage]: showNewHomepage })} id="app-header">
        <Content className={styles.header}>
          <a
            className={cx(styles.logo)}
            href="/"
            title={LocalT.translate('logoText')}
          >
            <LogoMotorway />
          </a>
          <div className={styles.menu}>
            <HeaderLinks />

            <AccountLinks />
          </div>
        </Content>
      </header>
    </>
  );
};

export default Header;
